import React from "react";
import SummaryDetailsItem from "@/src/components/Form/Common/SummaryDetailsItem/SummaryDetailsItem";
import SummaryDetailsProps from "@/src/types/SummaryDetailsProps";

const SummaryDetailsPurchase = ({ caseData: product }: SummaryDetailsProps) => {
  return (
    <>
      <SummaryDetailsItem fieldPath={"buyerOrSeller"} caseData={product} />
      <SummaryDetailsItem fieldPath={"channel"} caseData={product} />
      {product.buyerOrSeller === "buyer" && product.channel !== "fleaMarket" && product.channel !== "offline" && (
        <SummaryDetailsItem fieldPath={"contractNumber"} caseData={product} />
      )}
      <SummaryDetailsItem fieldPath={"itemTitle"} caseData={product} />
      {product.buyerOrSeller === "buyer" && product.articleNumber && <SummaryDetailsItem fieldPath={"articleNumber"} caseData={product} />}
      <SummaryDetailsItem fieldPath={"purchasePrice"} caseData={product} />
      <SummaryDetailsItem fieldPath={"buyerPaidStatus"} caseData={product} />

      <SummaryDetailsItem fieldPath={"goodsOrServiceProvidedStatus"} caseData={product} />

      {product.goodsOrServiceProvidedStatus !== "none" && (
        <>
          <SummaryDetailsItem fieldPath={"hasDefects"} caseData={product} />
          <SummaryDetailsItem fieldPath={"locationOfGood"} caseData={product} />
        </>
      )}

      {product.hasDefects === "yes" && (
        <>
          <SummaryDetailsItem fieldPath={"defectsDescriptionClient"} caseData={product} />
          <SummaryDetailsItem fieldPath={"numberRepairAttempts"} caseData={product} />
          <SummaryDetailsItem fieldPath={"numberReplacementAttempts"} caseData={product} />
        </>
      )}
    </>
  );
};

export default SummaryDetailsPurchase;
